import { Link } from 'react-router-dom';
import React from 'react';
import classNames from 'classnames';
import { routes } from '../../routes';
import { useTranslation } from 'react-i18next';
export const STEP_CONFIRM_METER_ID = 'step-confirm-meter';
export interface StepConfirmMeterProps {
  className?: string;
  message?: string;
  description?: string;
  actionLabel?: string;
  children?: JSX.Element | JSX.Element[];
  actions?: JSX.Element | JSX.Element[];
  dataTestId?: string;
}
export default function StepConfirmMeter({
  className,
  message,
  description,
  actionLabel,
  children,
  actions,
  dataTestId,
}: StepConfirmMeterProps) {
  const { t } = useTranslation();
  return (
    <div className={classNames('wizard', className)} data-test-id={dataTestId}>
      <div className="wizard__content">
        <h2>{message ?? t('step.confirm.message')}</h2>
        <p className="mb-3">{description ?? t('step.confirm.description')}</p>
        {children}
      </div>

      <div className="wizard__actions">
        {actions ? (
          actions
        ) : (
          <Link to={routes.OVERVIEW.path} className="btn btn--primary">
            {actionLabel ?? t('step.confirm.button.confirm')}
          </Link>
        )}
      </div>
    </div>
  );
}
